<div class="chat-interface" [ngClass]="[
    enableStudentThemes ? chatThemeClass : '',
    enableStudentThemes && juniorThemeActive ? 'junior-theme' : '',
    currentTheme === 'default' ? 'default-theme' : '',
    currentTheme === 'theme1' ? 'theme1' : '',
    currentTheme === 'theme2' ? 'theme2' : '',
    currentTheme === 'theme3' ? 'theme3' : '',
    currentTheme === 'theme4' ? 'theme4' : ''
  ]">
  <!-- Header -->
  <div class="main-chat-content">
    <div *ngIf="enableStudentThemes" class="chat-scene" aria-hidden="true">
      <div class="scene-cloud scene-cloud-left"></div>
      <div class="scene-cloud scene-cloud-right"></div>

      <span class="scene-star scene-star-1"></span>
      <span class="scene-star scene-star-2"></span>
      <span class="scene-star scene-star-3"></span>
      <span class="scene-star scene-star-4"></span>
      <span class="scene-star scene-star-5"></span>
      <span class="scene-star scene-star-6"></span>
      <span class="scene-star scene-star-7"></span>
      <span class="scene-star scene-star-8"></span>
      <span class="scene-star scene-star-9"></span>
      <span class="scene-star scene-star-10"></span>
    </div>
    <div *ngIf="enableStudentThemes && juniorThemeActive && messages.length === 0" class="theme-corner-decor" [ngClass]="'theme-corner-' + getThemeMascot()"></div>

    <img *ngIf="themeApplied==='learning_lane'" class="theme-top-image " src="assets/themes/note.png">
    <img *ngIf="themeApplied==='camp_wings'" class="camptheme-top-image " src="assets/themes/CampthemeChatTopImage.png">
    <header class="chat-header" *ngIf="messages.length > 0 && !['default', 'custom'].includes(themeApplied)">
      <div class="user-info flex items-center space-x-2">
        <div style="display: flex;">
          <img [src]="greetingIcon" alt="Greeting Icon" height="16" width="16" class="w-16 h-16" />
          <h1>{{ greetingMessage }}</h1>
        </div>

        <p>{{ this.user.user.name }}</p>
      </div>




      <div class="actions">
        <button class="save-pin" (click)="PinChat(true)">
          <img class="pin-chat" *ngIf="themeApplied !=='nebula_way'" src="assets/icon/PinnIconLightTheme.svg"
            alt="Pin Chat" width="16" height="16" />
          <img class="pin-chat" *ngIf="themeApplied ==='nebula_way'" src="assets/icon/PinDarktheme.svg" alt="Pin Chat"
            width="16" height="16" />
        </button>

        <!-- Theme Toggle Button -->
        <!-- <button class="theme-toggle" (click)="toggleTheme()">
          <i [class]="isDarkMode ? 'fas fa-sun' : 'fas fa-moon'" style="color: #a9a9a9;"></i>
        </button> -->
      </div>
    </header>
    <header class="chat-header" *ngIf="messages.length > 0 && ['default', 'custom'].includes(themeApplied)">
      <div class="user-info flex items-center space-x-2">
        <div style="display: flex;">
          <img [src]="greetingIcon" alt="Greeting Icon" height="16" width="16" class="w-16 h-16" />
          <h1>{{ messages[0].content }}</h1>
        </div>

        <!-- <p>{{ this.user.user.name }}</p> -->
      </div>




      <div class="actions">
        <button class="save-pin" (click)="PinChat(true)">
          <img class="pin-chat" *ngIf="themeApplied !=='nebula_way'" src="assets/icon/PinnIconLightTheme.svg"
            alt="Pin Chat" width="16" height="16" />
          <img class="pin-chat" *ngIf="themeApplied ==='nebula_way'" src="assets/icon/PinDarktheme.svg" alt="Pin Chat"
            width="16" height="16" />
        </button>

        <!-- Theme Toggle Button -->
        <!-- <button class="theme-toggle" (click)="toggleTheme()">
          <i [class]="isDarkMode ? 'fas fa-sun' : 'fas fa-moon'" style="color: #a9a9a9;"></i>
        </button> -->
      </div>
    </header>

    <!-- Main Content -->

    <main class="chat-content" #chatScrollContainer [class.keyboard-open]="showMathKeyboard">
      <div *ngIf="messages.length > 0" class="message-list" #chatContent (scroll)="onScroll()">
        <div *ngFor="let message of messages" class="message" [ngClass]="{
            'user-message': message.sender === 'user',
            'ai-message': message.sender === 'ai'
          }">
          <!-- <div class="message-content" [innerHTML]="formatMessage(message.content)"></div> -->
          <div class="chat-message message-content" [innerHTML]="formatMessage(message.content)"></div>

          <div class="message-info">
            {{ getTimeString(message.timestamp) }}
            <button *ngIf="message.sender === 'ai' && message.audioUrl" class="play-audio-button"
              (click)="toggleAudio(message.audioUrl, $event); $event.stopPropagation()" [disabled]="audioError"
              title="Play/Stop audio" [ngStyle]="{
              'color': themeApplied?.toLowerCase() === 'custom' ? themeColor : ''
            }">
              <i class="fas speaker" [ngClass]="{
        'fa-circle-stop': playingMessageUrl === message.audioUrl && !audioError,
        'fa-volume-up': playingMessageUrl !== message.audioUrl && !audioError,
        'fa-exclamation-circle': audioError
      }"></i>
            </button>

          </div>
        </div>

        <!-- Typing Indicator -->
        <div *ngIf="isTyping" class="message ai-message typing">
          <div class="message-content">
            <div class="typing-indicator">
              <img src="assets/ScholarX_Logo_Icon.svg" alt="Logo" class="logo-image"
                style="width: 17px; height: 17px;" />
              <span>ScholarX thinking</span>
              <span class="dots">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="welcome-message">
        <!-- <div class="logo">
          <img src="assets/ScholarX_Logo_Icon.svg" alt="Logo" class="logo-image" />
        </div> -->
        <!-- <h2 class="welcome-title gradient-text">Ask ScholarX</h2> -->
        <p class="welcome-subtitle" *ngIf="messages.length === 0" [ngStyle]="{
          'color': themeApplied?.toLowerCase() === 'custom' ? primaryColor : ''
        }">
          <img *ngIf="themeApplied !== 'nebula_way'" src="assets/SmilySun.png" alt="Sun Icon" class="greeting-icon" />
          <img *ngIf="themeApplied === 'nebula_way'" src="assets/grretingsIconDraktheme.svg" alt="Sun Icon"
            class="greeting-icon" />

          Good Day, {{ user.user.name }} <br />
          How can I assist you today?
        </p>

        <!-- <p class="welcome-subtitle">Good Morning Mark</p> -->

        <div class="chat-input " [class.moved]="isMoved" [class.subscription-expired]="subscriptionExpired">
          <div *ngIf="enableStudentThemes && juniorThemeActive" class="theme-input-mascot" [ngClass]="'theme-input-mascot-' + getThemeMascot()">
            <video
              *ngIf="getThemeMascot() === 'rainbow'"
              #rainbowMascotVideo
              class="rainbow-mascot-video"
              autoplay
              muted
              playsinline
              preload="auto"
              (ended)="onRainbowMascotEnded()"
              aria-hidden="true">
              <source src="assets/themes/ScholarX Rainbow Theme.mp4" type="video/mp4" />
            </video>
            <img *ngIf="getThemeMascot() === 'rocket'" src="assets/themes/RocketLightTheme.svg" alt="Rocket theme decoration" class="rocket-mascot-image" />
          </div>
          <form [formGroup]="chatForm" (ngSubmit)="sendMessage()" class="input-container">
            <textarea #messageInput [ngStyle]="themeApplied?.toLowerCase() === 'custom' ? { '--hover-border-color': themeColor } : {}"
              formControlName="message" placeholder="{{ subscriptionExpired ? 'Subscription expired. Please connect with school admin.' : 'Type a question, I will find the answer for you ...' }}"
              [maxlength]="maxLength" rows="1" (keydown.enter)="onEnter($event)" (input)="autoResizeTextarea()" [readonly]="subscriptionExpired"></textarea>

            <div class="input-footer">
              <span class="char-count">
                {{ chatForm.get('message')?.value?.length || 0 }}/{{ maxLength }}
              </span>

              <div class="input-actions">
                <!-- Keyboard Button -->
                <button type="button" class="keyboard-button" (click)="toggleMathKeyboard()" [disabled]="subscriptionExpired" [ngStyle]="{
                    'color': themeApplied?.toLowerCase() === 'custom' ? themeColor : ''
                  }">
                  <i class="fas fa-keyboard" style="font-size: smaller;"></i>
                </button>

                <!-- Mic Button -->
                <button type="button" class="mic-button " (click)="toggleSpeechRecognition()" [disabled]="subscriptionExpired" [ngStyle]="{
                    'color': themeApplied?.toLowerCase() === 'custom' ? themeColor : ''
                  }">
                  <i class="fas fa-microphone " style="font-size: smaller;"></i>
                </button>

                <!-- Send/Stop Button -->
                <button class="send-button" (click)="toggleRevealing()" [disabled]="subscriptionExpired" [ngStyle]="{
                    'background-color': themeApplied?.toLowerCase() === 'custom' ? primaryColor : ''
                  }">
                  <button class="icon-btn">
                    <i [ngClass]="{
                      'fa fa-arrow-up': !isRevealing && !isTyping,
                      'fa-solid fa-stop': isRevealing || isTyping
                    }"></i>
                  </button>
                </button>
              </div>
            </div>
          </form>
        </div>

        <!-- Math Keyboard - flows below input, page scrolls to show both -->
        <div class="math-keyboard" *ngIf="showMathKeyboard" [@slideUp] #mathKeyboardRef>
          <div class="keyboard-header">
            <div class="keyboard-tabs">
              <button class="keyboard-tab" [class.active]="activeKeyboardTab === 'operators'" (click)="activeKeyboardTab = 'operators'">+-×÷</button>
              <button class="keyboard-tab" [class.active]="activeKeyboardTab === 'functions'" (click)="activeKeyboardTab = 'functions'">f(x) e log ln</button>
              <button class="keyboard-tab" [class.active]="activeKeyboardTab === 'trig'" (click)="activeKeyboardTab = 'trig'">sin cos tan cot</button>
              <button class="keyboard-tab" [class.active]="activeKeyboardTab === 'calculus'" (click)="activeKeyboardTab = 'calculus'">lim dx ∫ Σ ∞</button>
              <button class="keyboard-tab" [class.active]="activeKeyboardTab === 'matrices'" (click)="activeKeyboardTab = 'matrices'">Matrix det</button>
            </div>
            <button class="close-keyboard-btn" (click)="toggleMathKeyboard()">
              Close keyboard <i class="fas fa-times"></i>
            </button>
          </div>

          <!-- Operators Tab -->
          <div class="keyboard-content" *ngIf="activeKeyboardTab === 'operators'">
            <button class="keyboard-key" *ngFor="let key of operatorKeys" (click)="insertSymbol(key.symbol)">
              {{ key.display }}
            </button>
          </div>

          <!-- Functions Tab -->
          <div class="keyboard-content" *ngIf="activeKeyboardTab === 'functions'">
            <button class="keyboard-key" *ngFor="let key of functionKeys" (click)="insertSymbol(key.symbol)">
              {{ key.display }}
            </button>
          </div>

          <!-- Trigonometry Tab -->
          <div class="keyboard-content" *ngIf="activeKeyboardTab === 'trig'">
            <button class="keyboard-key" *ngFor="let key of trigKeys" (click)="insertSymbol(key.symbol)">
              {{ key.display }}
            </button>
          </div>

          <!-- Calculus Tab -->
          <div class="keyboard-content" *ngIf="activeKeyboardTab === 'calculus'">
            <button class="keyboard-key" *ngFor="let key of calculusKeys" (click)="insertSymbol(key.symbol)">
              {{ key.display }}
            </button>
          </div>

          <!-- Matrices Tab -->
          <div class="keyboard-content" *ngIf="activeKeyboardTab === 'matrices'">
            <button class="keyboard-key" *ngFor="let key of matrixKeys" (click)="insertSymbol(key.symbol)">
              {{ key.display }}
            </button>
          </div>

          <!-- Greek Letters -->
          <div class="keyboard-greek-section">
            <button class="keyboard-key greek" *ngFor="let key of greekKeys" (click)="insertSymbol(key.symbol)">
              {{ key.display }}
            </button>
          </div>
        </div>


        <!-- <div class="suggestion-chips"*ngIf="messages.length === 0">
          <button *ngFor="let suggestion of suggestionChips" (click)="useChip(suggestion.label)">
            <img [src]="suggestion.icon" alt="icon" class="chip-icon" /> {{suggestion.label}}
          </button>
        </div> -->
        <div class="suggestion-chips" *ngIf="messages.length === 0 && !subscriptionExpired">
          <button *ngFor="let suggestion of suggestionChips" (click)="useChip(suggestion.label)"
            [ngStyle]="themeApplied?.toLowerCase() === 'custom' ? { '--hover-border-color': themeColor } : {}">
            <!-- Default theme -->
            <img *ngIf="themeApplied?.toLowerCase() !== 'custom'" [src]="suggestion.icon" alt="icon"
              class="chip-icon" />

            <!-- Custom theme -->
            <span *ngIf="themeApplied?.toLowerCase() === 'custom'" class="chip-icon" [innerHTML]="suggestion.iconSvg"
              style="margin-right: 6px; vertical-align: middle;"></span>

            {{ suggestion.label }}
          </button>
        
        </div>
          <div class="layout-decor" aria-hidden="true" *ngIf="enableStudentThemes && !showScienceDecor && !juniorThemeActive">
      <div class="layout-cloud layout-cloud-left"></div>
      <div class="layout-formula" *ngIf="isDarkTheme()"></div>
    </div>

        <div class="chat-formula" aria-hidden="true" *ngIf="messages.length === 0 && !juniorThemeActive"></div>



        <!-- <div class="suggestion-chips" *ngFor="let chip of suggestionChips">
          <button>
          <img [src]="chip.icon" alt="icon" class="chip-icon" />
          <span>{{ chip.label }}</span>
        </button>
        </div> -->
      </div>


    </main>
      
    <div class="disclaimer-text">ScholarX uses AI for assistance, verify important information with your teacher.</div>
  </div>

  <!-- Theme Switch Buttons (optional UI) -->
  <!-- <div class="theme-buttons">
    <button (click)="setTheme('default')">Default</button>
    <button (click)="setTheme('theme1')">Theme 1</button>
    <button (click)="setTheme('theme2')">Theme 2</button>
    <button (click)="setTheme('theme3')">Theme 3</button>
    <button (click)="setTheme('theme4')">Theme 4</button>
  </div> -->
</div>
